import { __rest, __assign } from 'tslib';
import React from 'react';
import clsx from 'clsx';

var BadgeV2 = function (_a) {
    var _b;
    var children = _a.children, _c = _a.type, type = _c === void 0 ? 'primary' : _c, className = _a.className, showLoader = _a.showLoader, _d = _a.hoverable, hoverable = _d === void 0 ? true : _d, outline = _a.outline, divProps = __rest(_a, ["children", "type", "className", "showLoader", "hoverable", "outline"]);
    return (React.createElement("div", __assign({ className: clsx((_b = {
                'c-badge': true,
                'c-badge--loader': showLoader
            },
            _b["c-badge--".concat(type)] = !!type,
            _b['c-badge--no-hover'] = !hoverable,
            _b['c-badge--outline'] = outline,
            _b), className) }, divProps), children));
};

export { BadgeV2 };
//# sourceMappingURL=BadgeV2.js.map
